import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=782bb60c&scoped=true"
import script from "./Link.js?vue&type=script&lang=js&external"
export * from "./Link.js?vue&type=script&lang=js&external"
import style0 from "./Link.scss?vue&type=style&index=0&id=782bb60c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782bb60c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
